import { Injectable } from '@angular/core';
import { WarningsDTO } from '../../shared/models/models';
import { ApiService } from 'src/app/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class EarlyWarningService {
  constructor(private apiService: ApiService) {}

  public getWarnings(dateString?: string) {
    const url = dateString ? `warning/lab?date=${dateString}` : 'warning/lab';

    return this.apiService.getAsObservable<WarningsDTO>(url);
  }

  public getWarningsByKriteria(dateString?: string) {
    const url = dateString ? `warning/criteria?date=${dateString}` : 'warning/criteria';

    return this.apiService.getAsObservable<WarningsDTO>(url);
  }

  public getWarningsByProvId(dateString?: string) {
    const url = dateString ? `warning/prov?date=${dateString}` : 'warning/prov';

    return this.apiService.getAsObservable<WarningsDTO>(url);
  }

}
